(function () {
  var SESSION_KEY = "sbPopupShown";

  document.querySelectorAll("[data-sb-popup]").forEach(function (popup) {
    if (sessionStorage.getItem(SESSION_KEY)) return;

    var delaySeconds = parseInt(popup.getAttribute("data-delay"), 10) || 50;

    var timer = setTimeout(function () {
      show();
    }, delaySeconds * 1000);

    function show() {
      if (sessionStorage.getItem(SESSION_KEY)) return;
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add("is-visible");
      });
      sessionStorage.setItem(SESSION_KEY, "1");
      document.addEventListener("keydown", onKeydown);
    }

    function hide() {
      popup.classList.remove("is-visible");
      document.removeEventListener("keydown", onKeydown);
      popup.addEventListener(
        "transitionend",
        function () {
          popup.hidden = true;
        },
        { once: true }
      );
    }

    function onKeydown(e) {
      if (e.key === "Escape") hide();
    }

    popup.querySelectorAll("[data-sb-popup-close]").forEach(function (el) {
      el.addEventListener("click", function () {
        clearTimeout(timer);
        hide();
      });
    });
  });
})();